const env = {
  SITENAME: 'Rise',
}

export default env
